import { useMemo } from 'react';

import { normalizeModuleKey } from './permission-utils';
import { usePremissionContext } from './use-permissions-context';

interface ModulePermissions {
  isView: boolean;
  isCreate: boolean;
  isImport: boolean;
  isExport: boolean;
  isEdit: boolean;
  isDelete: boolean;
  isUpdate: boolean;
  isPublish: boolean;
  isExecute: boolean;
  isPause: boolean;
  isResume: boolean;
  isCancel: boolean;
  isExecutions: boolean;
  isVersions: boolean;
  isStats: boolean;
  isTest: boolean;
  isMetadata: boolean;
}

export const useModulePermissions = (moduleName: string): ModulePermissions => {
  const { hasModuleActionPermission } = usePremissionContext();
  const key = normalizeModuleKey(moduleName);
  return useMemo(
    () => ({
      isView: hasModuleActionPermission(key, 'view'),
      isCreate: hasModuleActionPermission(key, 'create'),
      isImport: hasModuleActionPermission(key, 'import'),
      isExport: hasModuleActionPermission(key, 'export'),
      isEdit:
        hasModuleActionPermission(key, 'edit') ||
        ((key === 'workflow' || key === 'workflows') && hasModuleActionPermission(key, 'update')),
      isDelete: hasModuleActionPermission(key, 'delete'),
      isUpdate: hasModuleActionPermission(key, 'update'),
      isPublish: hasModuleActionPermission(key, 'publish'),
      isExecute: hasModuleActionPermission(key, 'execute'),
      isPause: hasModuleActionPermission(key, 'pause'),
      isResume: hasModuleActionPermission(key, 'resume'),
      isCancel: hasModuleActionPermission(key, 'cancel'),
      isExecutions: hasModuleActionPermission(key, 'executions'),
      isVersions: hasModuleActionPermission(key, 'versions'),
      isStats: hasModuleActionPermission(key, 'stats'),
      isTest: hasModuleActionPermission(key, 'test'),
      isMetadata: hasModuleActionPermission(key, 'metadata'),
    }),
    [hasModuleActionPermission, key]
  );
};

